<template>
  <v-content>

    <div class="flexiapp-bg-header-container" style="z-index: 0;"></div>
    <div class="flexiapp-bg"></div>

    <v-row v-if="!isLoading && !!errorMessage" cols="12" justify="center">
      <v-alert type="info" class="mx-auto col-10" justify="center">{{
        errorMessage
      }}</v-alert>
    </v-row>

    <v-row v-if="isLoading" cols="12" justify="center">
        <v-col class="mx-auto" cols="12">
            <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%" style="top: -20px !important; position: relative;"/>
        </v-col>
    </v-row>

    <v-row cols="12" justify="center" no-gutters v-if="!isLoading && !errorMessage"> 
      <v-col>
          <!-- Testigo Instalación  -->
        <v-card> <!-- class="mx-auto elevation-2 mb-3 card-flexiapps-home card-flexiapp-guide-view" -->
            <v-card-text>
                <!-- Loader -->
                <v-row v-if="isLoading" cols="12" justify="center">
                    <v-col class="mx-auto" cols="12">
                        <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%" />
                    </v-col>
                </v-row>
                
                <div class="flexiapp-card-flex-content">

                    <div class="flexiapp-type-container">{{this.containerType}}</div>
                    <div class="flexiapp-number-container">{{this.containerNumber}}
                        <v-panel v-if="isEmptyField(this.containerNumber)"> 
                         <span style="font-size: 0.875rem !important;">- -</span>
                        </v-panel>
                    </div>
                </div>
               
                <div class="flexiapp-card-flex-content">

                    <p color="primary" style="margin-bottom: 5px;">{{this.flexiType}}</p>
                    <div>{{this.flexiNumber}} 
                        <v-panel v-if="isEmptyField(this.flexiNumber)">  
                          <span style="color: #000000 !important;">- -</span>
                       </v-panel>
                    </div>
                </div>
                <v-row
                  justify="center"
                  align="center"
                 >
                   <v-chip
                     small
                     label
                     outlined
                     class="mb-2 ml-1"
                     v-if="this.bars"
                   >
                    {{ $t("order.bars.assemble")}}
                  </v-chip>
                </v-row>
                <!-- Comments --> 
                <div class="flexiapp-comments-container" v-if="!isEmptyField(this.comment)"><!-- Repetimos este div si hay más comentarios -->
                   <p class="pa-2 pt-1 flexiapp-comment-list-text">{{this.comment}}</p>
                </div>
                <!-- Progress Bar -->
                <div>
                    <v-progress-linear style="border-radius: 25px;"
                    :value="bar"
                    :color="barColor"
                    height="15"
                    ></v-progress-linear>
                </div> 
                <!-- Installer Comments --> 
                <div class="flexiapp-comments-container" v-if="!isEmptyField(this.depotComment)"><!-- Repetimos este div si hay más comentarios -->
                   <span class="pa-2 pb-0 mb-0 flexiapp-comment-text" style="font-weight: 500; color: rgba(0, 86, 183, 0.7);">{{$t("order.comments.employee")}}:</span>
                   <p class="pa-2 pt-0 mb-0 flexiapp-installer-comment-text">{{this.depotComment}}</p>
                </div> 

            </v-card-text>
            <v-card-actions style="justify-content: space-between; padding-bottom: 15px; padding-top: 0;">
                <v-btn
                   outlined
                   color="primary"
                   text
                   v-bind:disabled="isDisableEdit()"
                   @click="editLine({containerType:containerType,
                    containerNumber:containerNumber,
                    flexiType:flexiType,
                    flexiNumber:flexiNumber,
                    depotComment:depotComment
                    }, $event)"
                >
                  {{$t("guide.edit")}}
                </v-btn>

                <v-btn
                   outlined
                   color="black"
                   text
                   v-bind:disabled="!isReadyToFinalize"
                    @click="doFinalizeLine()"
                >
                  {{$t("guide.finalize")}}
                </v-btn>
            </v-card-actions>

        </v-card>

      </v-col>
    </v-row>    
    

    <v-row v-if="!isLoading && !errorMessage" cols="12" justify="center" no-gutters style="margin-top: 10px; padding-bottom: 50px;"> 
      <v-col>

        

        <v-card class="elevation-2 mb-3" v-if="isEmptySteps()">
            <v-card-text>
                <v-alert
                 colored-border
                 icon="mdi-information-outline"
                 class="flexiapp-empty-content"
                >
                 {{$t("common.noInfo")}}
                </v-alert>
            </v-card-text>
        </v-card>

        <v-card id="selectUploadImagesType" v-show="calculateUploadedStepImages() <= 0"
        color="white"
        class="mx-auto my-2 card-flexiapps-home pa-0"
        min-height="auto"
        tile
        >
            <v-card-text>
                <h3
                class="primary--text" style="text-transform: uppercase;"
                >
                    {{$t("guide.uploadImages.title")}}
                </h3>
                <p 
                class="font-weight-normal secondary--text">
                    {{$t("guide.uploadImages.description")}}
                </p>
                <v-radio-group v-model="imageUploadType">
                    <v-radio value="freeImagesType"
                    style="align-items: flex-start;" checked>
                        <template v-slot:label>
                            <div>
                                <p
                                class="black--text mb-0"
                                style="font-size: 14px;">
                                    {{$t("guide.uploadImages.galleryTitle")}}
                                </p>
                                <p
                                style="font-size: 13px;">
                                    {{$t("guide.uploadImages.galleryDescription")}}
                                </p>
                            </div>
                        </template>
                    </v-radio>
                    <v-radio value="guideType"
                    style="align-items: flex-start;">
                        <template v-slot:label>
                            <div>
                                <p
                                class="black--text mb-0"
                                style="font-size: 14px;">
                                    {{$t("guide.uploadImages.guideTitle")}}
                                </p>
                                <p
                                style="font-size: 13px;">
                                    {{$t("guide.uploadImages.guideyDescription")}}
                                </p>
                            </div>
                        </template>
                    </v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-actions
            style="padding: 25px; margin-top: -50px; justify-content: end;">
                <v-btn
                outlined
                color="primary"
                @click="acceptUploadImageType()"
                >{{$t("guide.uploadImages.acceptButton")}}</v-btn>
            </v-card-actions>
        </v-card>

        <v-card id="freeImagesCard" style="margin-bottom: 20px;" v-show="calculateUploadedStepImages() > 0 || (this.status==5 || this.status==6)">
            <v-container>
                <v-row>
                    <!--<h3 style="text-transform: uppercase;">{{$t("guide.incident.image")}}</h3>-->
                    <v-col cols="12" sm="12" md="12" align="center">
                    <p style="font-size: 13px; margin-bottom: 0px;">
                        {{$t("guide.freeImages.label")}}
                    </p>                        
                    <div v-for="(item, index) in userImages.filter(img => !img.assembleStepId)" :key="index">
                    <v-img                       
                        :class="isUploadPending(null, item.token) ? 'blur' : ''"
                        v-if="isImageUploaded(null, item.token)"
                        :lazy-src="$i18n.locale=='es'?'img/imagen-no-disponible.png' : 'img/imagen-no-disponible-en.png'" 
                        max-height="150"
                        max-width="250"
                        :src="getImage(null, item.token)"
                        @click="viewImage(null, item.token)"
                    >
                    </v-img>
                    <v-btn
                        :id="'deleteButton'"
                        style="display: block;"
                        text
                        color="red"
                        @click="doDeleteImage(null, item.token)"
                        v-if="isImageUploaded(null, item.token)"
                    >
                    {{$t("guide.btn.deletePic")}}
                    </v-btn>
                    </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" align="center">
                    <!-- <v-btn
                    outlined
                    color="red"
                    class="ma-2 white--text"
                    v-bind:disabled="assembleSteps.length == 0 || !isReadyToFinalize"
                    @click="doFinalizeLine()"
                    >
                    {{$t("guide.finalize")}}
                    </v-btn> -->
                    <IconPictureUploader
                    :workorderId= "workorderId"
                    :lineId= "lineId"
                    v-on:pic-uploaded="listImages(true)"
                    />
                    </v-col>                     
                </v-row>
                </v-container>
        </v-card>        

        <div id="guideSteps" v-show="(calculateUploadedStepImages() > 0 && getUploadImageType() == 'guideType') || (this.status==5 || this.status==6)">
            <v-card  v-for="item in assembleSteps" :key="item.assembleStep.id"
            class="mx-auto elevation-2 mb-3"
            >
            <v-card-text style="padding: 8px;">
                <v-container class="order-container" style="padding: 0;">
                    <v-row no-gutters>
                        <v-col cols="12" sm="7" md="7">
                            <h3 class="text--primary" style="margin-bottom: 10px;">
                            {{item.assembleStep.title}}
                            </h3>
                            <div>{{item.assembleStep.text}}</div>
                        </v-col>
                        <v-col :cols="!isImageUploaded(item.assembleStep.id, null) ? '6' : '12'" sm="5" md="5" align="center" v-if="!isImageUploaded(item.assembleStep.id, null)"> 
                            <CameraPictureUploader
                                prependIcon=""
                                :assembleStepId= "item.assembleStep.id"
                                :workorderId= "workorderId"
                                :lineId= "lineId"
                                v-if="!isImageUploaded(item.assembleStep.id, null)"
                                v-on:pic-uploaded="listImages(true)"
                                />                        
                        </v-col>                                                  
                        <v-col :cols="isImageUploaded(item.assembleStep.id, null) ? '12' : '6'" sm="5" md="5" align="center">
                            <v-img 
                            :class="isUploadPending(item.assembleStep.id, null) ? 'blur' : ''"
                            v-if="isImageUploaded(item.assembleStep.id, null)"
                            :lazy-src="$i18n.locale=='es'?'img/imagen-no-disponible.png' : 'img/imagen-no-disponible-en.png'"                           
                            max-height="150"
                            max-width="250"
                            :src="getImage(item.assembleStep.id, null)"
                            @click="viewImage(item.assembleStep.id, null)"
                            >
                            
                            </v-img>
                            <IconPictureUploaderStepByStep
                                prependIcon=""
                                :assembleStepId= "item.assembleStep.id"
                                :workorderId= "workorderId"
                                :lineId= "lineId"
                                v-if="!isImageUploaded(item.assembleStep.id, null)"
                                v-on:pic-uploaded="listImages(true)"
                                />
                            <v-btn
                            :id="'deleteButton'"
                            style="display: block;"
                            v-if="isImageUploaded(item.assembleStep.id, null)"
                            text
                            color="red"
                            @click="doDeleteImage(item.assembleStep.id, null)"
                            >
                            {{$t("guide.btn.deletePic")}}
                            </v-btn>

                            <v-col class="flexiapp-img-cola-container"
                            v-if="isUploadPending(item.assembleStep.id, null)">
                            
                                <v-icon
                                    x-large
                                    color="white"
                                    class="pa-1"
                                    style="font-size: 80px; text-shadow: 0px 2px #000000;"
                                >mdi-camera-retake-outline
                                </v-icon>
                            <label
                                class="text--primary"
                                style="font-size: 15px; font-weight: 600; line-height: 1.375rem; letter-spacing: 0.0071428571em; color: rgba(255, 255, 255, 1) !important; text-shadow: 0px 1px #000000;"
                                
                            >{{$t("guide.icon.uploadPending")}}
                            </label>
                            </v-col>
                            
                        </v-col>                      
                    </v-row>
                </v-container>
            </v-card-text>
            </v-card>
        </div>
        
     </v-col>
    </v-row>

    <EditDialog
      ref="confirmEditLine"
      v-bind:title="$t('common.editDialogTitle')"
      v-bind:message="$t('line.edit.description')"
      v-bind:titleOk="$t('common.OK')"
      v-bind:titleCancel="$t('common.close')"
      v-on:confirmed="doEditLine($event)"
    />

    <ImagesDialog
    ref="imagesDialog"
    />

      <v-snackbar
        style="z-index:100002"
        v-model="putError"
        :top="true"
        class="fixNotchMarginTop"
        :timeout="2000"
        color="error"
      >
        {{putErrorMessage}}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="putError = null">{{$t('HISTORY_CLOSE')}}</v-btn>
        </template>
      </v-snackbar>
  </v-content>
</template>


<script>
// eslint-disable-next-line no-unused-vars
import api from "../../../api/flexiapp";
import BaseModule from "../../common/BaseModule"; 
import IconPictureUploader from "./IconPictureUploader";
import CameraPictureUploader from "./CameraPictureUploader";
import IconPictureUploaderStepByStep from "./IconPictureUploaderStepByStep";
import discovery from '../../../discovery';
import PictureManager from '../../common/PictureManager';
import EditDialog from "./EditDialog";
import ImagesDialog from "./ImagesDialog";

export default {
  name: "OrderMain",
  mixins: [BaseModule],
  components: {IconPictureUploader,CameraPictureUploader, IconPictureUploaderStepByStep, EditDialog, ImagesDialog},
  props: ['workorderId','lineId','status', 'flexiType', 'flexiNumber', 'containerType', 'containerNumber', 'bars', 'comment', 'depotComment'],
  data() {
    return {
      show: false,
      isLoading: false,
      isReadyToFinalize:false,
      bar:null,
      barColor:null,
      putErrorMessage:null,
      putError:false,
      uploadQueue: null,
      errorMessage: null,
      line : {},
      assembleSteps: [],
      userImages: [],
      userLineImagesLength:0,
      imageUploadType: 'freeImagesType'
    };
  },
  computed: {
    },
  methods: {
      listarItems: function () {
        this.errorMessage= null;
        this.assembleSteps = [];
        this.isLoading = true;

      api.getAsseembleGuideSteps(
        this.workorderId,
        this.lineId,
        (data) => {
          this.isLoading = false;
          this.assembleSteps = data;
          this.$store.commit('flexiapp/setNavTitle', this.$t('guide.header'));
          this.listImages(false);
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage=error; 
          this.$log.error(error); 
        }
      );
    },
    listImages: function (silent) {
      this.isLoading = true && !silent;
      api.getUserImages(
        this.workorderId,
        this.lineId,
        (data) => {
            this.isLoading = false;
            this.uploadQueue = PictureManager.getQueue();
            this.userImages = data;
            this.userLineImagesLength = this.calculateUploadedStepImages();
            this.isUpdateLineStatus();
        },
        (error) => {
            this.isLoading = false;
            this.errorMessage=error; 
            this.$log.error(error); 
            }
        );       
      },
    getImageUploaded(id, token) {
        var image = null;
        if (this.userImages != null) {
            if (id) {
                image = this.userImages.find(img => img.assembleStepId == id);
            } else {
                image = this.userImages.find(img => img.token == token);
            }
        }
        if (image && image.token == null) {
                image = null;
        }
        return image;
    },
      getImage(id, token){
        var image = this.getImageUploaded(id, token);
        if(image == null){
            return null;
        }
        return discovery.flexiapp_service_url+'api/Images/'+image.token;

        //Buscamos en el almacenamiento local
        /*image = this.findPendingPicture(id);
        if(image!=null) {
            return 'data:image/jpeg;base64,'+image.image;
        }*/

    },
      /*findPendingPicture(id)
      {
          return this.uploadQueue.find(e=>e.assembleStepId == id);
      },*/
    isUploadPending(id, token) {
        const image = this.getImageUploaded(id, token);
        if (image != null && image.token == null) {
            return true;
        }
        return false;
    },
    isImageUploaded(id, token) {
      const image = this.getImageUploaded(id, token);
        if (image != null && image.token != null) {
            return true;
        }
        return false;
    },
      isEmptyField(field){
        return field== null  ||  field.length == 0; 
      }, 
      isEmptySteps(){
          return this.assembleSteps.length == 0;
      },
      isDisableEdit(){
          return this.status==5 || this.status==6
      },
      doFinalizeLine() {
        var data ={
                "status":  5,
        }
        this.doUpdateLineStatus(data);
      },
      onPictureUploaded(picture)
      {
          if (picture.workorderId == this.workorderId && picture.lineId ==this.lineId) {
              this.listImages(true);
          }
      },
      isUpdateLineStatus() {
            var calculatedStatus = 0;
            //check if all images have been uploaded
            //var isAllUploaded = this.userLineImagesLength == this.assembleSteps.length;
            //var isAnyUploaded = this.userImages != null && this.userLineImagesLength > 0;
            var isStatusChanged = false;
            //If all steps images are uploaded, line is completed. If line status is not "Completed", then update
            //If NOT all steps images are uploaded, but line status is not "In progress", then update
            if(this.status!=null){
                /*if(isAllUploaded && (this.status==2 || this.status==4) && this.status!=5 && this.status!=6){
                    calculatedStatus=3;
                    isStatusChanged = true;
                }else */
                if (this.status!=2 && this.status!=5 && this.status!=6){
                    calculatedStatus=2;
                    isStatusChanged = true;
                }
            }

            if(isStatusChanged){
                var data ={
                    "status":  calculatedStatus,
                }
                this.doUpdateLineStatus(data);
            }
        },
        doUpdateLineStatus(data){
            api.putWorkOrderLine(
                this.workorderId,
                this.lineId,
                data,
                () => {
                        this.$store.commit('flexiapp/onWorkorderEvent', Date.now());
                        this.status = data.status;
                        this.bar=this.calculateBar(data.status);
                        this.barColor=this.calculateBarColor(data.status);
                        this.isReadyToFinalize=this.calculateReadyToFinalize(data.status,this.flexiNumber,this.containerNumber)
                    },
                (error) => {
                    this.putErrorMessage=error.response.data ? error.response.data : error ;
                    this.putError=true;
                    this.$log.error(error); 
            });
        },   
        doDeleteImage(id, token){
            document.getElementById('deleteButton').style.display="none";
            
            var image = this.getImageUploaded(id, token);

            if(image!=null && image.token!=null){ 
                api.deleteImageByToken(
                    this.workorderId,
                    this.lineId,
                    image.id,
                    () => {
                            this.listImages(true);
                            this.isUpdateLineStatus();
                        },
                    (error) => {
                        this.putErrorMessage=error.response.data ? error.response.data : error ;
                        this.putError=true;
                        this.$log.error(error); 
                });
                }
        },
        calculateBar(status){
            var result = 0;
            if(status==2 || status==4){
                result = 50;
            }else if(status==3 || status==5 || status==6){
                result = 100;
            }
            return result;
        },
        calculateBarColor(status){
            var result = "amber";
            if(status==5 || status==6){
                result = "green";
            }
            return result;
        },
        calculateReadyToFinalize(status, flexiNumber, containerNumber){
            return (status==3 || status==2 || status==1) && flexiNumber && containerNumber;
        },
        editLine(item) {
            this.$refs.confirmEditLine.confirm(item.flexiNumber, item.containerNumber, item.depotComment);
        },
        doEditLine(item) {
            this.isLoading = true; 

            var data ={
                    "flexiNumber":  item.flexiNumber,
                    "containerNumber":  item.containerNumber,
                    "depotComment": item.depotComment
                }

            api.putWorkOrderLine(
            this.workorderId,
            this.lineId,
            data,
            () => {
                    this.isLoading=false;
                    this.listarItems();
                    this.flexiNumber=data.flexiNumber;
                    this.containerNumber=data.containerNumber;
                    this.depotComment=data.depotComment;
                    this.isReadyToFinalize=this.calculateReadyToFinalize(this.status,data.flexiNumber,data.containerNumber)
                },
                (error) => {
                    this.isLoading=false;
                    this.$log.error(error); 
                    this.putErrorMessage=error.response.data ? error.response.data : error ;
                    this.putError=true;
            });
        },
        calculateUploadedStepImages(){
             var userLineImagesLength = 0;
             for(var i in this.userImages){
                if(this.userImages[i].token!=null){
                    userLineImagesLength=userLineImagesLength+1;
                }
            }
            return userLineImagesLength;
        },
        processBackButton(){
            window.$vue.$off('ne_backbutton');
            this.$router.push({ name: 'order' , params: { id: this.workorderId}});
        },
        viewImage(id, token) {
            const image = this.getImageUploaded(id, token);
            const url = discovery.flexiapp_service_url + 'api/Images/' + image.token;
            this.$refs.imagesDialog.showDialog(url, image.token);
        },
        acceptUploadImageType() {
            var imagesUploadType = null;
            
            if(this.imageUploadType != null) {

                imagesUploadType = this.imageUploadType;

                if (imagesUploadType == 'freeImagesType') {
                    localStorage.setItem('imagesUploadType', 'freeImagesType');
                    document.getElementById('freeImagesCard').style.display = "block";                    
                    document.getElementById('guideSteps').style.display = "none";
                } else if (imagesUploadType == 'guideType') {
                    localStorage.setItem('imagesUploadType', 'guideType');
                    document.getElementById('freeImagesCard').style.display = "block";                    
                    document.getElementById('guideSteps').style.display = "block";
                } else {
                    return;
                }
            }

            document.getElementById('selectUploadImagesType').style.display = "none";
        }, 
        getUploadImageType() {

            var imgUploadType = localStorage.getItem('imagesUploadType');

            if(imgUploadType === null || imgUploadType === ''){
                imgUploadType = 'guideType';
            }

            return imgUploadType;
            
        },                    
   },
   mounted: function() {
        
   },
  watch: {
    //TODO: fix header when route changes!
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
        if(to.name == 'guide'){
            this.workorderId = to.params.workorderId;
            this.lineId = to.params.lineId;
            this.listarItems();
        }
    },
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.listarItems();
        vm.isReadyToFinalize=vm.calculateReadyToFinalize(vm.status,vm.flexiNumber,vm.containerNumber);
        vm.bar = vm.calculateBar(vm.status);
        vm.barColor = vm.calculateBarColor(vm.status);

        window.$vue.$off('picture-uploaded');
        window.$vue.$on('picture-uploaded', vm.onPictureUploaded);
        window.$vue.$off('ne_backbutton');
        window.$vue.$on('ne_backbutton', vm.processBackButton);
      })
    }
};
</script>
